import Vue from 'vue'

import iotForm from './iot-form'


// 注意 有些组件使用异步加载会有影响
Vue.component('iot-form', iotForm)
